import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {GIGYA_KEY} from "data/constants";
import {ConnextraType, createConnextraScript} from "data/utils/createConnextraScript";
import type {IUserStore} from "data/stores/user/user.store";

export interface IDashboardController extends ViewController {
	readonly i18n: ILocalizationStore;

	goToMyAccount: () => void;
	SSOLogin: () => void;
}

@injectable()
export class DashboardController implements IDashboardController {
	constructor(
		@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore,
		@inject(Bindings.UserStore) private _userStore: IUserStore
	) {
		makeAutoObservable(this);
	}

	public goToMyAccount = () => {
		window.location.href = `https://id.nfl.com/account?redirectUrl=${window.location.href}`;
	};

	public SSOLogin = () => {
		window.gigya?.sso.login({
			authFlow: "redirect",
			apiKey: GIGYA_KEY,
		});
	};

	init(param: void) {
		createConnextraScript(ConnextraType.HOME, this._userStore.user?.id);
	}
}
